import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=7fc93fbf&scoped=true&"
import script from "./CompanyHeader.vue?vue&type=script&lang=js&"
export * from "./CompanyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc93fbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
